module.exports = __webpack_public_path__ + "static/media/carrorama-duvida.22373e0a.jp2";